import { useLazyQuery } from '@apollo/client';
import { QUERY_GET_PERSONS_FROM_INTEGRATION } from 'services/aws/integration-query';

const useIntegration = ({ integration }) => {
  const [fetchPersons] = useLazyQuery(QUERY_GET_PERSONS_FROM_INTEGRATION);

  const getExternalPersons = async ({ entityId }) => {
    const { data } = await fetchPersons({
      variables: {
        entityId,
        integrationType: integration
      },
      fetchPolicy: 'network-only'
    });

    if (data?.getPersonsFromIntegration) {
      return data.getPersonsFromIntegration.map(person => ({
        ...person,
        personId: '',
        status: false,
        problems: [],
        entityId
      }));
    }
    return [];
  };

  return { getExternalPersons };
};

export default useIntegration;
